let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = Promise.all([load("eErVv"), load("6wr18"), load("5jrmX"), load("ffEVr"), load("1pG9q")]).then(() => parcelRequire('99jPR'));